'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../../../utils/index.js');

var _index2 = _interopRequireDefault(_index);

var _loveButton = require('../loveButton/loveButton.js');

var _loveButton2 = _interopRequireDefault(_loveButton);

var _itemActions = require('photography-client-lib/dist/src/item/itemActions');

var _biLogger = require('photography-client-lib/dist/src/utils/biLogger');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _consts = require('photography-client-lib/dist/src/utils/consts');

var _consts2 = _interopRequireDefault(_consts);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Social = function (_React$Component) {
  (0, _inherits3.default)(Social, _React$Component);

  function Social() {
    (0, _classCallCheck3.default)(this, Social);
    return (0, _possibleConstructorReturn3.default)(this, (Social.__proto__ || (0, _getPrototypeOf2.default)(Social)).apply(this, arguments));
  }

  (0, _createClass3.default)(Social, [{
    key: 'getSocialShare',
    value: function getSocialShare() {
      var _props = this.props,
          styleParams = _props.styleParams,
          id = _props.id,
          actions = _props.actions;

      if (styleParams.allowSocial) {
        var slideshowShareButton = _react2.default.createElement('i', { className: 'block-fullscreen progallery-svg-font-icons-share-store' });
        if (_index2.default.isSite()) {
          var slideshowShare = styleParams.isSlideshow ? actions.getShare() : '';
          return _react2.default.createElement(
            'div',
            { className: 'block-fullscreen gallery-item-social-share gallery-item-social-button',
              'data-hook': 'gallery-item-social-button',
              key: 'item-social-share-' + id,
              onClick: function onClick(e) {
                return actions.toggleShare(e, true);
              } },
            slideshowShareButton,
            slideshowShare
          );
        } else {
          return _react2.default.createElement(
            'div',
            { className: 'show-tooltip block-fullscreen gallery-item-social-share gallery-item-social-button',
              'data-hook': 'gallery-item-social-button',
              key: 'item-social-share-' + id,
              onMouseOver: function onMouseOver(e) {
                return _itemActions.itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor');
              },
              onMouseOut: function onMouseOut() {
                return _itemActions.itemActions.hideTooltip();
              },
              onClick: function onClick(e) {
                return e.stopPropagation();
              }
            },
            slideshowShareButton
          );
        }
      }
      return '';
    }
  }, {
    key: 'getLoveButton',
    value: function getLoveButton() {
      var _props2 = this.props,
          styleParams = _props2.styleParams,
          love = _props2.love;

      var props = _lodash2.default.pick(this.props, ['id', 'item', 'idx', 'styleParams', 'hashtag', 'love']);
      return styleParams.loveButton ? _react2.default.createElement(_loveButton2.default, (0, _extends3.default)({}, props, {
        itemId: this.props.photoId,
        layout: styleParams.isSlideshow ? 'slideshow' : 'gallery',
        showCounter: love && love.showCounter
      })) : '';
    }
  }, {
    key: 'getDownload',
    value: function getDownload() {
      var item = _lodash2.default.pick(this.props, ['html', 'style']);
      var _props3 = this.props,
          styleParams = _props3.styleParams,
          isDemo = _props3.isDemo,
          type = _props3.type,
          download_url = _props3.download_url;

      if (styleParams.allowDownload && !_index2.default.isiOS() && !(_index2.default.isSite() && isDemo)) {
        var className = 'block-fullscreen gallery-item-social-download ' + (styleParams.allowSocial ? '' : ' pull-right ') + ' gallery-item-social-button';
        var downloadIcon = _react2.default.createElement('i', { className: 'block-fullscreen progallery-svg-font-icons-download' + (isDemo ? ' inactive' : '') });

        var genralProps = {
          className: className,
          'data-hook': 'item-download'
        };
        var downloadLink = download_url.mp4 || download_url.webm || download_url.img;
        var itemProps = {
          target: '_blank',
          href: downloadLink,
          onClick: function onClick(e) {
            e.stopPropagation();
            e.preventDefault();
            _windowWrapper2.default.open(downloadLink, '_blank');
            _biLogger.logger.trackBi(_biLogger.logger.biEvents.download, { origin: 'gallery' });
          }
        };
        if (type === 'text') {
          return _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, genralProps, {
              onClick: function onClick(e) {
                e.stopPropagation();
                _itemActions.itemActions.downloadTextItem(item, 'gallery');
              } }),
            downloadIcon
          );
        } else {
          var props = isDemo ? {
            onMouseOver: function onMouseOver(e) {
              return _itemActions.itemActions.showTooltip(e, 'Gallery_Hover_Download_FreeImages_Text');
            },
            onMouseOut: function onMouseOut() {
              return _itemActions.itemActions.hideTooltip();
            }
          } : itemProps;
          return _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, genralProps, {
              download: 'download',
              role: 'button'
            }, props),
            downloadIcon
          );
        }
      }
      return '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          styleParams = _props4.styleParams,
          id = _props4.id,
          showShare = _props4.showShare,
          isSmallItem = _props4.isSmallItem,
          isNarrow = _props4.isNarrow,
          isShort = _props4.isShort,
          isVerticalContainer = _props4.isVerticalContainer;

      var socialShare = this.getSocialShare();
      var loveButton = this.getLoveButton();
      var download = this.getDownload();
      //var shopIcons = this.getShopIcons();
      var isShowArrows = styleParams.hasThumbnails;
      var isPopulated = styleParams.allowSocial || styleParams.loveButton || styleParams.allowDownload;
      var textPlacementAboveOrBelow = styleParams.titlePlacement === _consts2.default.placements.SHOW_BELOW || styleParams.titlePlacement === _consts2.default.placements.SHOW_ABOVE;

      var classes = [[showShare, 'hidden'], [isSmallItem, 'small-item'], [isShort, 'short-item'], [isNarrow, 'narrow-item'], [isVerticalContainer, 'vertical-item'], [isShowArrows, 'with-arrows'], [isPopulated, 'populated-item'], [textPlacementAboveOrBelow, 'text-external-item']].filter(function (x) {
        return x[0];
      }).map(function (x) {
        return x[1];
      }).join(' ');

      return _react2.default.createElement(
        'div',
        {
          className: 'gallery-item-social gallery-item-direction-' + styleParams.galleryTextAlign + ' ' + classes,
          key: 'item-social-' + id,
          'data-hook': 'item-social'
        },
        loveButton,
        download,
        socialShare
      );
    }
  }]);
  return Social;
}(_react2.default.Component);

exports.default = Social;